import { createTheme, type PaletteMode, type ThemeOptions } from '@mui/material'

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true
    sm: true
    md: true
    lg: true
    xl: true
    xxl: true
  }
}

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 810,
      md: 1000,
      lg: 1366,
      xl: 1440,
      xxl: 1920,
    },
  },
})

const fontFamily = 'Inter Variable'
const typography = {
  fontFamily: fontFamily,
  h1: {
    fontFamily: fontFamily,
  },
  h2: {
    fontFamily: fontFamily,
  },
  h3: {
    fontFamily: fontFamily,
  },
  h4: {
    fontFamily: fontFamily,
  },
  h5: {
    fontFamily: fontFamily,
  },
  h6: {
    fontFamily: fontFamily,
    fontWeight: 700,
  },
}

const settings = {
  light: {
    palette: {
      mode: 'light',
      background: {
        default: '#FFFFFF',
      },
      primary: {
        main: '#00782A',
      },
      secondary: {
        main: '#F5A302',
      },
      text: {
        primary: '#000000',
        secondary: '#F5A302',
      },
    },
    typography,
    components: {},
    breakpoints: theme.breakpoints,
  },
}

const getThemeOptions = (mode: PaletteMode) => settings['light'] as ThemeOptions

export default getThemeOptions
